import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await axios.post(`${API}/newsletter`, { email });
      setStatus("ok"); setEmail("");
    } catch { setStatus("error"); }
  };
  return (
    <footer className="lux-footer" id="contact" data-testid="site-footer">
      <div className="lux-footer-grid">
        <div className="footer-col brand-col">
          <img className="footer-logo" src="/logo-256.png" alt="Arisha Creations" data-testid="footer-logo" />
          <p className="footer-tagline">Ladies-garment manufacturers crafting quiet, considered pieces from Mumbai since 1998.</p>
        </div>

        <div className="footer-col">
          <p className="footer-heading">Shop</p>
          <Link to="/shop">All pieces</Link>
          <Link to="/shop?category=Kurtis">Kurtis</Link>
          <Link to="/shop?category=Anarkali">Anarkali</Link>
          <Link to="/shop?category=Dresses">Dresses</Link>
          <Link to="/shop?category=Festive%20Wear">Festive wear</Link>
        </div>

        <div className="footer-col">
          <p className="footer-heading">Help</p>
          <Link to="/track">Track your order</Link>
          <a href="https://wa.me/919769128394" target="_blank" rel="noreferrer">WhatsApp support</a>
          <a href="tel:+919769128394">Call +91 9769128394</a>
        </div>

        <div className="footer-col">
          <p className="footer-heading">Reach us</p>
          <address className="footer-address" data-testid="footer-address">
            G.K. Garment, Arisha Creations, First Floor,<br />
            Shop No. 11, New Gautam Nagar,<br />
            P.L. Lokhande Marg Road, Govandi West,<br />
            Mumbai 400043
          </address>
          <a href="https://maps.app.goo.gl/YBftTijqG1YGxPyr9" target="_blank" rel="noreferrer" data-testid="office-map-link" className="footer-link">View on Google Maps ↗</a>
          <a href="tel:+919769128394" data-testid="footer-phone" className="footer-link">+91 9769128394</a>
          <a href="https://wa.me/919769128394" target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="footer-link">Chat on WhatsApp</a>
        </div>

        <div className="footer-col">
          <p className="footer-heading">The Arisha letter</p>
          <p className="footer-sub">Slow updates from the atelier — new arrivals, care tips, quiet stories.</p>
          <form className="newsletter" onSubmit={subscribe} data-testid="newsletter-form">
            <input type="email" required placeholder="your email" value={email} onChange={e => setEmail(e.target.value)} data-testid="newsletter-email-input" />
            <button type="submit" disabled={status === "loading"} data-testid="newsletter-submit-button">{status === "loading" ? "…" : "Subscribe →"}</button>
          </form>
          {status === "ok" && <p className="newsletter-status ok" data-testid="newsletter-success">Thank you. Welcome to Arisha.</p>}
          {status === "error" && <p className="newsletter-status err">Something went wrong. Try again.</p>}
        </div>
      </div>
      <div className="lux-footer-strip">
        <small>© {new Date().getFullYear()} Arisha Creations · Manufactured with intention in India</small>
        <small>Secure payments via Razorpay · UPI · Cards · Net banking</small>
      </div>
    </footer>
  );
}
